import "../scss/_woocommerce.scss";

import { activeClass } from "../../src/js/modules/helpers";

const miniCart = document.querySelector("[data-mini-cart]");

function miniCartToggleActiveState() {
miniCart.classList.toggle(activeClass);
}

document.addEventListener("keydown", (e) => {
if (e.key == "Escape" && miniCart.classList.contains(activeClass)) {
    miniCartToggleActiveState();
}
});

const togglers = document.querySelectorAll("[data-mini-cart-toggler]");
togglers.forEach((toggler) => {
toggler.addEventListener("click", (event) => {
    event.preventDefault();
    miniCartToggleActiveState();
});
});

//Mini cart animation after product add
jQuery(document.body).on("added_to_cart", function () {
    jQuery("[data-mini-cart-toggler='main-link']")
        .addClass("added-to-cart-animation")
        .on("animationend", function () {
        jQuery(this).removeClass("added-to-cart-animation");
        });
});
